export function foldName(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

function byId(a, b) {
  return a.id - b.id;
}

// Prefix matches come first, then names that only contain the text.
// A typed number matches dex numbers that start with those digits.
export function rankNames(entries, typed) {
  const raw = String(typed || '').trim();
  const query = foldName(raw);
  if (!query) return [];
  if (/^\d+$/.test(raw)) {
    return (entries || [])
      .filter((entry) => String(entry.id) === raw || String(entry.id).startsWith(raw))
      .sort(byId);
  }
  const exact = [];
  const prefix = [];
  const contains = [];
  (entries || []).forEach((entry) => {
    const name = foldName(entry.name);
    const slug = foldName(entry.slug);
    if (name === query || slug === query) exact.push(entry);
    else if (name.startsWith(query) || slug.startsWith(query)) prefix.push(entry);
    else if (name.includes(query) || slug.includes(query)) contains.push(entry);
  });
  return [...exact.sort(byId), ...prefix.sort(byId), ...contains.sort(byId)];
}

// The untyped tail of a prefix match, so "sand" + "shrew" completes Sandshrew.
export function ghostSuffix(typed, name) {
  const raw = String(typed || '');
  if (!raw || !name) return '';
  const query = foldName(raw);
  if (!query || !foldName(name).startsWith(query)) return '';
  let built = '';
  for (let i = 0; i < name.length; i += 1) {
    built += name[i];
    const folded = foldName(built);
    if (folded === query) return name.slice(i + 1);
    if (folded.length > query.length) break;
  }
  return '';
}
